module.exports = __webpack_public_path__ + "static/img/share.android.752fdb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/share.android.png
// module id = 1413
// module chunks = 382